import { render } from "./BaseSpinner.vue?vue&type=template&id=5147169a&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=5147169a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5147169a"

export default script